module.exports = __webpack_public_path__ + "static/media/person-icon.d20cf722.svg";